<template lang="pug">
  .share
    .card-share
      .user
        .name {{username}}
        .text 在「有道词典」口语提升打卡
      ul.record
        li.word
          em 速记单词(个)
          p {{vocabularyNum}}
      .words
        .en " Only the road is right, do not be afraid, it is short or distant, the road is right, do not be. "
        .cn 只要路是对的，就不要害怕它是短暂还是遥远。
    .button(@click="share",data-rlog="explore_share_download") 前往有道词典，和TA一起进步

</template>

<script>

  export default {
    name: 'Share',
    data() {
      return {
        username:'',
        vocabularyNum:this.$route.query['vocabularyNum'],
        reading:this.$route.query['reading'],
        spoken:this.$route.query['spoken'],
        words:['What\'s coming will come,','and we\'ll meet it','when it does.'],
      }
    },
    mounted() {
      _rlog.push(["_trackCustom" , 'action' , 'explore_share_show']);

      this.splitCN(decodeURIComponent(this.$route.query['name']))

    },
    methods: {
      splitCN(name){
        let writeName=''
        const REG_CHINESE = /[\u4e00-\u9fa5]/g;
        const chineseLength = name.match(REG_CHINESE) ? name.match(REG_CHINESE).length : 0;
        const len=name.length+chineseLength
        if(len>=14){
          let j=0
          for(let i=0;j<14;i++){
            if(name[i].match(REG_CHINESE)){
              j=j+2
            }else {
              j++
            }
            writeName+=name[i]
          }
          writeName+='...'
        }else {
          writeName=name
        }
        this.username=writeName
      },
      share(){

        window.location.href='https://sj.qq.com/myapp/detail.htm?apkName=com.youdao.dict'

      }
    },
    components: {

    }
  }
</script>

<style lang="stylus" scoped>
  .share
    position relative
    width 7.5rem
    height 100%
    //overflow hidden

  /*  .img
      position absolute
      left 0
      top 0
      width 7.5rem
      height 100%
      z-index 0
      background:rgba(47,52,62,0.7);
      filter:blur(.05rem);*/

  .card-share
    margin 0.45rem auto 0
    width:6.40rem;
    height:9.63rem;
    background:url("../assets/popup.png");
    background-size 6.4rem 9.64rem
    box-shadow:0px 8px .50rem 0px rgba(111,123,181,0.18);
    border-radius:.12rem;
    overflow hidden

  .user
    margin-top 0.77rem
    margin-left 0.6rem
    height 1.20rem

  .name
    width fit-content
    max-width 4rem
    position relative
    height:.59rem;
    font-size:.42rem;
    font-family:PingFangSC-Semibold;
    font-weight:600;
    color:rgba(48,53,61,1);
    line-height:.59rem;

  /*.name:after
    position absolute
    right -0.2rem
    bottom 0.1rem
    content ""
    width:.12rem;
    height:.12rem;
    background:rgba(244,53,67,1);
    border-radius 50%
*/
  .text
    margin 0.1rem 0 0 0rem
    height:.40rem;
    font-size:.28rem;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(184,188,194,1);
    line-height:.40rem;

  .record
    margin-top 0.35rem
    width 100%
    height 1.46rem
    display flex
    flex-direction row

  .record li.word
    margin-left 0.6rem
    height 1rem

  .record li.speak
    margin-left 0.58rem
    width 1.55rem
    height 1rem

  .record li.reading
    margin-left 0.62rem
    width 1.16rem
    height 1rem

  .record p
    height:1.01rem;
    font-size:.82rem;
    line-height 1.01rem
    font-family:AvertaStd-Bold;
    font-weight:bold;
    color:rgba(48,53,61,1);

  .record em
    font-style normal
    height:.37rem;
    font-size:.26rem;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(111,114,117,1);
    line-height:.37rem;

  .words
    margin 0.48rem auto 0
    width 5.19rem
    height 2.62rem

  .en
    width 5.19rem
    height:1.23rem;
    font-size:.28rem;
    font-family:AvertaStd-Semibold;
    font-weight:600;
    color:rgba(154,158,164,1);
    line-height:.41rem;

  .cn
    margin-top 0.12rem
    width:3.92rem;
    height:.72rem;
    font-size:.22rem;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(154,158,164,1);
    line-height:.36rem;
    -webkit-background-clip:text;

  .button
    margin 0.41rem auto 0
    width:6.4rem;
    height:.96rem;
    line-height 0.96rem
    text-align center
    background:rgba(247,57,68,1);
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.2);
    border-radius:.12rem;
    font-size:.32rem;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);

</style>




// WEBPACK FOOTER //
// src/components/Share.vue